import { CalendarOutlined } from '@ant-design/icons';
import { AlgoliaMedia, UserRoles } from '@omniafishing/core';
import classNames from 'classnames';
import dayjs from 'dayjs';
import React from 'react';
import { Link } from 'react-router-dom';
import buSrc from '../../assets/bu.svg';
import iconPlay from '../../assets/icon-play.svg';
import { getImgixPath } from '../../lib/imgix';
import { OmniaUrls } from '../../lib/urls';
import { roleAsText } from '../../lib/user';
import { getBassULink } from '../../prismic';
import { AmbassadorColorDot } from '../ambassador_color_dot/ambassador_color_dot';
import { AmbassadorLink } from '../ambassador_link/ambassador_link';
import fallbackImg from '../search_universal/fallback-image.png';
import { UserProfileImg } from '../user_profile_img/user_profile_img';
import styles from './algolia_media_card.less';
import iconArticle from './icon-article.svg';
interface MediaCardProps {
  media: AlgoliaMedia;
  imgWidth?: number;
  onClick?: () => void;
  className?: string;
  target?: '_blank';
}

const OMNIA_MASTER_USER_SLUG = 'ofishing';

export const AlgoliaMediaCard = (props: MediaCardProps) => {
  const { media, imgWidth, onClick, className, target } = props;
  const { media_type, slug, published_at, thumbnail, title, tags, creator } = media;

  const isBassU = media_type === 'BassUArticle';
  const w = imgWidth || 600;
  const h = Math.round(w * 0.666666667);

  let url;
  if (media_type === 'PrismicVideo') {
    url = OmniaUrls.video(slug);
  }
  if (media_type === 'PrismicArticle') {
    url = OmniaUrls.article(slug);
  }
  if (media_type === 'BassUArticle') {
    url = getBassULink(slug);
  }
  if (media_type === 'OmniaVideo') {
    url = OmniaUrls.omniaVideo({ slug });
  }

  const isVideo =
    media_type === 'PrismicVideo' || media_type === 'OmniaVideo' || tags.includes('video');

  const allowedRoles: UserRoles[] = ['ambassador_gold', 'ambassador_blue'];

  const content = (
    <>
      <div className={styles.img}>
        <img
          src={thumbnail ? getImgixPath(thumbnail, { w }) : fallbackImg}
          alt={title}
          loading="lazy"
          width={w}
          height={h}
        />

        {isVideo ? (
          <>
            <span className={styles.badge}>
              <img src={iconPlay} className={styles.badgeIcon} /> Video
            </span>
            {thumbnail && <img src={iconPlay} className={styles.iconPlay} />}
          </>
        ) : (
          <>
            <span className={styles.badge}>
              <img src={iconArticle} className={styles.badgeIcon} /> Article
            </span>
          </>
        )}
      </div>
      {published_at && (
        <p className={styles.publicationDate}>
          <CalendarOutlined />
          {dayjs(published_at).format('MMM, D, YYYY')}
        </p>
      )}
      <p className={styles.title}>{title}</p>
    </>
  );

  const link = isBassU ? (
    <a
      href={url}
      className={classNames(styles.link, className)}
      onClick={() => {
        onClick?.();
      }}
      target={target}
    >
      {content}
      <span style={{ backgroundImage: `url(${buSrc})` }} className={styles.source}></span>
    </a>
  ) : (
    <Link
      to={url}
      className={classNames(styles.link, className)}
      onClick={() => {
        onClick?.();
      }}
      target={target}
    >
      {content}
    </Link>
  );

  return (
    <div>
      {link}
      {creator && creator.slug !== OMNIA_MASTER_USER_SLUG && allowedRoles.includes(creator.role) && (
        <AmbassadorLink ambassador={creator}>
          <div className={styles.userContainer}>
            <div className={styles.userImageContainer}>
              <UserProfileImg image={creator.image} imageSize={50} size={36} />
            </div>

            <div className={styles.userDetails}>
              <p className={styles.userName}>{creator.full_name || 'Omnia Community Member'}</p>

              <p className={styles.role}>
                <AmbassadorColorDot user={creator} />
                {roleAsText(creator.role)} Ambassador
              </p>
            </div>
          </div>
        </AmbassadorLink>
      )}
    </div>
  );
};
